export const msleep = (
  ms: number
): Promise<number> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};